import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HomeUrls } from '../enums/home-urls';

export const rootRedirectGuard: CanActivateFn = (route, state) => {
  const currentDomain = window.location.hostname;
  const router = inject(Router);

  console.log('State URL:', state.url);

  if (currentDomain !== 'chilepasajes.cl' && currentDomain !== 'qa.chilepasajes.cl') {
    // Use setTimeout to defer the redirect until after Angular has finished loading
    setTimeout(() => {
      if (currentDomain in HomeUrls) {
        window.location.replace(HomeUrls[currentDomain]);
      }
    }, 0);

    if (currentDomain in HomeUrls) {
      return false;
    } else {
      return true;
    }
  }

  return true;
};
